<template>
  <div style="padding:15px;">
    <keep-alive :include="['DriverManage', 'PlatVehicle']">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "Driver"
};
</script>